import React from 'react';
import classnames from 'classnames';
import ArrowDown from '../../Icons/ArrowDown';
import NativeDropdown from '../NativeDropdown';
import noop from '../../utils/noop';
import s from './MobileNativeDropdown.scss';
/**
 * A dropdown that uses the native select and meant for mobile UIs
 */
export var MobileNativeDropdown = function (_a) {
    var items = _a.items, title = _a.title, className = _a.className, titleClassName = _a.titleClassName, arrowClassName = _a.arrowClassName, _b = _a.onSelect, onSelect = _b === void 0 ? noop : _b;
    return (React.createElement("div", { className: classnames(s['native-dropdown-wrap'], className) },
        React.createElement("div", { className: s['native-dropdown-title-wrap'], "aria-hidden": "true" },
            React.createElement("div", { className: classnames(s['native-dropdown-title'], titleClassName) }, title),
            React.createElement(ArrowDown, { className: classnames(s['native-dropdown-arrow'], arrowClassName) })),
        React.createElement("div", { className: s['native-dropdown-hidden'] },
            React.createElement(NativeDropdown, { onSelect: onSelect, items: items }))));
};
MobileNativeDropdown.displayName = 'MobileNativeDropdown';
export default MobileNativeDropdown;
//# sourceMappingURL=MobileNativeDropdown.js.map